import { ref, reactive, onMounted, computed, onActivated, watchEffect, getCurrentInstance, onDeactivated } from 'vue';
import request, { cancelFnMap } from '@/utils/request.js';
import { downloadNewV, mediaEnu, getCompanyInfo } from '@/utils/index';
import storeState from '../../store/index';
import router from '@/router/index.js';
import popupNew from '@/commponents/popupNew.vue';
// import unServer from '@/commponents/unServer.vue'
// import homeHot from '@/commponents/homeHot'
// 当没有渠道邀请码是不请求书籍列表  getBookList
export default {
  name: 'Home',
  components: {
    popupNew
  },
  setup() {
    // const userId = computed(()=> storeState.getters.id)
    let pageData = reactive({
      bookList: [],
      banner: [],
      notice: {},
      taskCountMap: {}
    });
    let companyList = computed(() => storeState.getters.companyList);
    let no_see_count = computed(() => storeState.getters.no_see_count);
    let type = ref(''); // 媒体类型
    let limit = ref(10);
    let pageSize = ref(1);
    const refreshing = ref(false); // 下拉刷新
    const {
      proxy
    } = getCurrentInstance();
    let menuPop = reactive({
      sex: '',
      sort: '',
      freeNum: 0,
      // 创建推广时的免费章节数
      sexTxt: '全部',
      sortTxt: '最新',
      // revenueTxt: '支付',
      upshow: false,
      popupPush: false,
      popupData: {}
    });
    let loading = ref(false); // 当次页数据加载完成
    let finished = ref(false); // 列表接口分页加载完成，是否有下一页
    let isOver = ref(false); // 当前接口请求完

    let showPopover = ref(false);
    let showMenuPopover = ref(false);
    // let showRevenuePopover = ref(false)
    let bookHome = ref(null);
    let isapp = ref(window.VideoJsBridge ? true : false);
    let pageStatus = ref('view');
    const actions = [{
      text: '最新',
      value: ''
    }, {
      text: '最热',
      value: '2'
    }];
    const actionsMenu = [{
      text: '全部',
      value: ''
    }, {
      text: '男频',
      value: 1
    }, {
      text: '女频',
      value: 2
    }];
    onMounted(() => {
      // ----------------服务关停-----------------------
      // downloadNewV()
      // getTaskCount()

      // request.post('/v1/Koc/swiper', {}).then(res => {
      //   if (res.length) pageData.banner = res
      //   else pageData.banner = []
      // })

      // const stop = watchEffect(() => {
      //   if (companyList.value.length > 0) {
      //     type.value = companyList.value[0] && companyList.value[0].company_type || ''
      //     getBookList()
      //   }
      // })

      // setTimeout(() => stop(), 1000)
      // ----------------服务关停-----------------------
    });

    // 页面缓存激活状态
    onActivated(() => {
      // ----------------服务关停-----------------------
      // request.post('/v1/Koc/notice', {}).then(res => {
      //   if (res.type) {
      //     menuPop.popupPush = true
      //     pageData.notice = res
      //   }
      // })
      // ----------------服务关停-----------------------

      if (pageStatus.value == 'hidden') {
        pageStatus.value = 'view';
      }
    });
    onDeactivated(() => {
      pageStatus.value = 'hidden';
    });
    const getTaskCount = () => {
      request.post('/v1/Koc/taskCount', {}).then(res => {
        pageData.taskCountMap = res;
      });
    };

    /**
     * @description: tab切换
     * @param {*} index
     * @param {*} title
     * @return {*}
     */
    const changeTab = (id, name) => {
      if (name === '河马剧场') {
        router.push({
          path: '/hema'
        });
        return false;
      }
      if (id) type.value = id;
      pageData.bookList = [];
      if (type.value) {
        pageSize.value = 1;
        loading.value = false;
        finished.value = false;
        isOver.value = false;
        getBookList();
      } else {
        isOver.value = true;
        loading.value = false;
      }
      sensorsLog('sub', {
        id
      });
    };

    // 获取书籍列表
    const getBookList = () => {
      const url = '/v1/Koc/booklistv1';
      const data = {
        page_num: pageSize.value,
        page_size: limit.value,
        book_type_one: menuPop.sex,
        sort_type: menuPop.sort,
        revenue_type: menuPop.revenue,
        company_type: type.value
        // revenue_type: menuPop.revenue
      };

      const cancelPreFetch = cancelFnMap.get(url);
      if (cancelPreFetch) {
        cancelPreFetch('tab切换过快，取消上次请求');
      }
      request.post(url, data, {}, true).then(res => {
        isOver.value = true;
        loading.value = true; // 第一页数据加载完好自动设置false
        if (pageSize.value == 1) {
          pageData.bookList = res.rows || [];
        } else {
          pageData.bookList = pageData.bookList.concat(res.rows);
        }
        if (pageSize.value * limit.value >= res.total) finished.value = true;
        // console.log('pageData.bookList.length',pageData.bookList.length, res.total ,finished.value,loading.value)
        setTimeout(() => {
          loading.value = false;
        }, 500);
      }).catch(() => {
        loading.value = false;
        finished.value = true;
        isOver.value = true;
      });
    };

    /**
     * @description: 下拉刷新
     * @return {*}
     */
    const onRefresh = () => {
      // 列表初始化数据
      refreshing.value = false;
      pageSize.value = 1;
      pageData.bookList = [];
      // 清空列表数据
      finished.value = false;
      isOver.value = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      loading.value = true;
      getBookList();
    };

    // 分页加载
    const onLoad = () => {
      if (!finished.value && isOver.value) {
        pageSize.value = pageSize.value + 1;
        isOver.value = false;
        getBookList();
      }
    };

    /**
     * @description: 刷选条件选择后
     * @param {*} action
     * @return {*}
     */
    const onSelect = (action, type) => {
      menuPop[type] = action.value;
      menuPop[type + 'Txt'] = action.text;
      changeTab();
    };

    /**
     * @description: 跳转详情页方法
     * @param {*} item 模块数据
     * @param {*} ctype 模块
     * @return {*}
     */
    const lookDetail = (item, ctype, index) => {
      let bookId = item.bookId,
        tid = item.task_id,
        isInfo = '',
        resource_type = " ";
      // banner点击
      if (ctype == 'banner') {
        bookId = item.book_id || item.id;
        tid = item.task_id;
        isInfo = item.resource_type;
        sensorsLog('br', {
          number: index,
          resource_id: item.id,
          resource_line: type.value + '',
          resource_type: item.resource_type == 4 ? '富文本' : item.resource_type == 5 ? '推广任务' : item.resource_type == 6 ? 'banner榜单' : '短剧',
          book_id: item.book_id,
          book_name: item.book_name,
          event_type: 'click'
        });
      }
      if (isInfo == 4) {
        router.push({
          path: '/notice/' + bookId
        });
        return false;
      }
      // banner位榜单列表
      if (isInfo == 6) {
        router.push({
          path: '/banner',
          query: {
            banner_name: item.banner_name,
            resource_id: item.id
          }
        });
        return false;
      }
      router.push({
        path: '/planDetail',
        query: {
          book_id: bookId,
          company_type: type.value
        }
      });
      resource_type = '推广任务';
      // 列表详情页点击
      if (ctype == 'detail') {
        sensorsLog('br', {
          number: '',
          resource_id: '',
          resource_line: type.value + '',
          resource_type: resource_type,
          book_id: item.bookId,
          book_name: item.bookName,
          event_type: 'click'
        });
      }
      menuPop.popupPush = false;
    };

    /**
     * @description: 关闭弹窗
     * @return {*}
     */
    const closeFun = () => {
      menuPop.popupPush = false;
    };

    /**
     * @description: 轮播变更
     * @param {*} index
     * @return {*}
     */
    const swipeChange = index => {
      let bitem = pageData.banner[index];
      if (pageStatus.value == 'view') {
        sensorsLog('br', {
          number: index,
          resource_id: bitem.id,
          resource_line: '',
          resource_type: bitem.resource_type == 4 ? '富文本' : bitem.resource_type == 5 ? '推广任务' : '短剧',
          book_id: bitem.book_id,
          book_name: bitem.book_name
        });
      }
    };

    /**
     * @description: 神策打点
     * @param {*} type 类型
     * @param {*} data 神策时间对象
     * @return {*}
     */
    const sensorsLog = (type, data) => {
      let logInfo = {
        event_type: 'show'
      };
      switch (type) {
        case 'sub':
          logInfo.resource_line = data.id;
          logInfo.event_type = 'click';
          logInfo.resource_type = '首页';
          break;
        case 'br':
          logInfo = Object.assign(logInfo, data);
        default:
          break;
      }
      proxy.$sensors('clickandShow', logInfo);
    };

    /**
     * @description: 
     * @param {*} type
     * @return {*}
     */
    const goSearch = () => {
      router.push({
        path: '/search'
      });
    };
    /**
     * @description: 
     * @param {*} type
     * @return {*}
     */
    const goNewList = () => {
      router.push({
        path: '/newList'
      });
    };
    return {
      no_see_count,
      pageData,
      loading,
      finished,
      type,
      menuPop,
      isOver,
      mediaEnu,
      refreshing,
      showPopover,
      actions,
      showMenuPopover,
      actionsMenu,
      isapp,
      companyList,
      bookHome,
      getBookList,
      onLoad,
      changeTab,
      onRefresh,
      lookDetail,
      closeFun,
      swipeChange,
      onSelect,
      getCompanyInfo,
      goSearch,
      getTaskCount,
      goNewList
    };
  }
};